import { Box } from '@factorialco/deprecated-design-system'
import { F0Text } from '@factorialco/f0-react'

import { contentContainer } from 'modules/trainings/components/content/styles.vanilla.css'
import { ContentViewProps } from 'modules/trainings/components/content/types'
import { ContentModule } from 'modules/trainings/lib/content/Module'

import {
  moduleContainerFullscreen,
  moduleContainerPreview,
  titleStyle,
  titleStyleFullscreen,
} from './ModuleView.vanilla.css'

const ModuleView = ({ contentItem, isFullscreen }: ContentViewProps<ContentModule>) => {
  const height = isFullscreen ? 'full' : 's400'
  const position = isFullscreen ? 'fixed' : undefined
  const containerClassName = isFullscreen ? moduleContainerFullscreen : moduleContainerPreview
  const maxWidth = isFullscreen ? 'full' : 's600'
  const paddingX = isFullscreen ? undefined : 's32'
  const innerClassName = isFullscreen ? contentContainer : ''
  const textStyle = isFullscreen ? titleStyleFullscreen : titleStyle

  return (
    <Box
      width="full"
      height={height}
      alignItems="center"
      justifyContent="center"
      position={position}
      className={containerClassName}
    >
      <Box maxWidth={maxWidth} paddingX={paddingX} className={innerClassName}>
        <F0Text content={contentItem.title} variant="body" style={textStyle} />
      </Box>
    </Box>
  )
}

export { ModuleView }
